import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  breadCrumbOrderList: {
    id: 'order.breadcrumb.list',
    defaultMessage: 'Order List',
  },
  breadCrumbOrderDetail: {
    id: 'order.breadcrumb.detail',
    defaultMessage: 'Order Detail',
  },
  detailTitle: {
    id: 'orderDetail.title',
    defaultMessage: 'Order Detail',
  },
  mapRouteTitle: {
    id: 'orderDetail.mapRouteTitle',
    defaultMessage: 'Map Route',
  },
  orderTrackingTitle: {
    id: 'orderDetail.orderTrackingTitle',
    defaultMessage: 'Order Tracking Status',
  },
  form: {
    label: {
      orderId: {
        id: 'orderDetail.label.orderId',
        defaultMessage: 'Order ID',
      },
      danaUser: {
        id: 'orderDetail.label.danaUser',
        defaultMessage: 'Dana User',
      },
      senderName: {
        id: 'orderDetail.label.senderName',
        defaultMessage: 'Sender Name',
      },
      senderLocation: {
        id: 'orderDetail.label.senderLocation',
        defaultMessage: 'Sender Location',
      },
      phoneNumber: {
        id: 'orderDetail.label.phoneNumber',
        defaultMessage: 'Phone Number',
      },
      dateTime: {
        id: 'orderDetail.label.dateTime',
        defaultMessage: 'Date and Time Completed',
      },
      status: {
        id: 'orderDetail.label.status',
        defaultMessage: 'Status',
      },
      recipientName: {
        id: 'orderDetail.label.recipientName',
        defaultMessage: 'Recipient Name',
      },
      recipientLocation: {
        id: 'orderDetail.label.recipientLocation',
        defaultMessage: 'Recipient Location',
      },
      courierBy: {
        id: 'orderDetail.label.courierBy',
        defaultMessage: 'Courier By',
      },
      serviceType: {
        id: 'orderDetail.label.serviceType',
        defaultMessage: 'Service Type',
      },
      awb: {
        id: 'orderDetail.label.awb',
        defaultMessage: 'AWB',
      },
      itemCategory: {
        id: 'orderDetail.label.itemCategory',
        defaultMessage: 'Item Category',
      },
      driverName: {
        id: 'orderDetail.label.driverName',
        defaultMessage: 'Driver Name',
      },
      vehicleNumber: {
        id: 'orderDetail.label.vehicleNumber',
        defaultMessage: 'Vehicle Number',
      },
      totalPayment: {
        id: 'orderDetail.label.totalPayment',
        defaultMessage: 'Total Payment',
      },
      source: {
        id: 'orderDetail.label.source',
        defaultMessage: 'Source From',
      },
    },
  },
  btn: {
    backBtn: {
      id: 'orderDetail.btn.backBtn',
      defaultMessage: 'Back',
    },
  },
});
